import { List, Text, VStack } from "@chakra-ui/react"
import Tip, { TipProps } from "../../tips/Tip"

export function HomeWelcomeAllTransitionalBlankSlateTip(
  props: Partial<TipProps>
) {
  return (
    <Tip
      tip={{
        id: "home-welcome-all-transitional-blank-slate",
        title: `Welcome to your new Home Screen`,
        content: (
          <VStack>
            <Text color="inherit" mt={0}>
              The new Home Screen below unifies all your Paths into a focused
              screen. You can now:
            </Text>
            <List.Root
              as="ul"
              marginInlineStart="1em"
              listStyleType="disc"
              _marker={{ color: "inherit" }}
            >
              <List.Item>Move any Path to the top of the list.</List.Item>
              <List.Item>
                Set aside Paths you no longer need to see (but without changing
                anything)
              </List.Item>
              <List.Item>Create or join Paths much more quickly.</List.Item>
            </List.Root>
          </VStack>
        )
      }}
      icon="lightbulb-on"
      layout="dismissable"
      colorPalette="dark"
      {...props}
    />
  )
}

export default HomeWelcomeAllTransitionalBlankSlateTip
